export const PayoutAccountType = {
  SAVING: 'Ahorro',
  CHECKING: 'Corriente',
  MASTER: 'Maestra'
}
